// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-up.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/chevron-up'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronUpIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
